const DEFAULT_PAD = 8

export function placeMenu({
  x = 0,
  y = 0,
  width = 240,
  height = 160,
  vw = 1024,
  vh = 768,
  pad = DEFAULT_PAD,
} = {}) {
  const maxLeft = Math.max(pad, vw - width - pad)
  const maxTop = Math.max(pad, vh - height - pad)
  let left = Number(x) || 0
  let top = Number(y) || 0

  if (left + width + pad > vw) {
    left = vw - width - pad
  }
  if (left < pad) left = pad
  if (left > maxLeft) left = maxLeft

  if (top + height + pad > vh) {
    const flipped = (Number(y) || 0) - height
    top = flipped >= pad ? flipped : vh - height - pad
  }
  if (top < pad) top = pad
  if (top > maxTop) top = maxTop

  return { left, top }
}

export function arrowDirectionFromRects(trigger, menu) {
  const triggerBox = trigger || { left: 0, top: 0, width: 0, height: 0 }
  const menuBox = menu || { left: 0, top: 0, width: 0, height: 0 }
  const triggerCx = triggerBox.left + (triggerBox.width || 0) / 2
  const triggerCy = triggerBox.top + (triggerBox.height || 0) / 2
  const menuCx = menuBox.left + (menuBox.width || 0) / 2
  const menuCy = menuBox.top + (menuBox.height || 0) / 2
  const dx = menuCx - triggerCx
  const dy = menuCy - triggerCy
  if (Math.abs(dx) > Math.abs(dy)) {
    return dx >= 0 ? 'right' : 'left'
  }
  return dy >= 0 ? 'down' : 'up'
}

export function menuSize(element) {
  if (!element) return { width: 240, height: 160 }
  const rect = element.getBoundingClientRect()
  return {
    width: Math.ceil(rect.width) || 240,
    height: Math.ceil(rect.height) || 160,
  }
}

export function placeAnchoredMenu({
  trigger = { left: 0, top: 0, width: 0, height: 0 },
  width = 240,
  height = 160,
  vw = 1024,
  vh = 768,
  pad = DEFAULT_PAD,
  gap = 8,
  align = 'end',
  prefer = 'below',
} = {}) {
  const box = {
    left: Number(trigger.left) || 0,
    top: Number(trigger.top) || 0,
    width: Number(trigger.width) || 0,
    height: Number(trigger.height) || 0,
  }
  const spaceBelow = Math.max(0, vh - box.top - box.height - pad)
  const spaceAbove = Math.max(0, box.top - pad)
  const preferBelow = prefer !== 'above'
  const openUp = preferBelow
    ? height + gap > spaceBelow && spaceAbove > spaceBelow
    : !(height + gap > spaceAbove && spaceBelow > spaceAbove)
  const available = openUp ? spaceAbove : spaceBelow
  const usedHeight = Math.max(48, Math.min(height, available || height))
  const left = align === 'start'
    ? box.left
    : box.left + box.width - width
  const top = openUp
    ? box.top - usedHeight - gap
    : box.top + box.height + gap
  return {
    ...placeMenu({ x: left, y: top, width, height: usedHeight, vw, vh, pad }),
    maxHeight: usedHeight,
    openUp,
  }
}
